import { cn } from '@/lib/utils';

interface PhoneMockupProps {
  children: React.ReactNode;
  className?: string;
}

export function PhoneMockup({ children, className }: PhoneMockupProps) {
  return (
    <div className={cn("relative mx-auto", className)}>
      {/* Phone frame */}
      <div className="relative bg-foreground/90 rounded-[2rem] p-1.5 shadow-xl">
        {/* Dynamic island */}
        <div className="absolute top-3 left-1/2 -translate-x-1/2 w-16 h-4 bg-foreground rounded-full z-10" />
        
        {/* Screen */}
        <div className="relative bg-background rounded-[1.5rem] overflow-hidden">
          {children}
        </div>
      </div>
    </div>
  );
}
